<template>
  <main class="l-main p-register">
    <div class="l-block">
      <PaymentLocalNav />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>お支払い方法を選択してください。</h1>
        </div>
        <ul class="p-plan-payment-list">
          <li class="p-plan-payment-list__item">
            <Button
              :to="{ name: 'paymentCard' }"
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
            >
              クレジットカード払い
            </Button>
          </li>
          <li class="p-plan-payment-list__item">
            <Button
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
              :class="{ 'is-loading': isProcessing }"
              :disabled="isProcessing"
              @click="submit"
            >
              請求書払い
            </Button>
          </li>
        </ul>
        <Alert v-if="errorResponse" class="l-mt-4">
          {{ errorResponse }}
        </Alert>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Progress from '@/components/Progress';
import PaymentLocalNav from '@/components/payment/PaymentLocalNav';
import TitleRegister from '@/components/TitleRegister';
import apiOrgs from '@/api/orgs';

export default {
  components: {
    Alert,
    Button,
    Progress,
    PaymentLocalNav,
    TitleRegister
  },
  data() {
    return {
      errorResponse: '',
      params: Object.assign({}, this.$store.state.payment.params),
      progress: [
        {
          label: 'プランの選択'
        },
        {
          current: true,
          label: 'お支払い方法の選択'
        },
        {
          label: 'カード情報の入力'
        }
      ],
      isProcessing: false
    };
  },
  created() {
    if (!this.params.planId) {
      this.$router.push({ name: 'paymentPlan' });
    }
  },
  methods: {
    submit() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      // 請求書払い用のplanIdを送る
      let params = {
        planId: '5tyka'
      };
      apiOrgs.subscriptions.invoices
        .post(params, this.auth.idToken)
        .then(response => {
          this.$store.dispatch('payment/reset');
          this.$store.dispatch('user/getPlan').finally(() => {
            this.$router.push({ name: 'projects' });
          });
        })
        .catch(error => {
          if (error.response) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
